import { render } from "./AdvantagesSection.vue?vue&type=template&id=003b9abc"
import script from "./AdvantagesSection.vue?vue&type=script&lang=js"
export * from "./AdvantagesSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/unipar/Code/neo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__